//import selectn          from 'selectn'
import getSportFromRoot  from './getSportFromRoot'
import qs                from 'query-string'
import { translateQueryKey } from './translateURI'

export default function getRequestParams( edition = {}, routerParams = {}, location = {} ) {

  let query         = location.query || qs.parse(location.search) || {}

  //translate query
  query = translateQueryKey(edition, query, true)

  const params        = routerParams.params || {}
  const currRoot      = params.sport || edition.defaultSport /* the variable is called sport but it could be a league */
  const actualSport   = getSportFromRoot( currRoot ) || currRoot
  const pageType      = params.pageType || ''
  const slug          = params.slug || query.slug || ''
  const actualLeague  = params.league || query.league || query.leagueId || ''
  const actualGameId  = params.gameId || query.gameId || ''
  const actualSeason  = params.season || query.season || ''
  let actualTeam      =  ''
  let actualPlatform  =  params.platform || query.platform || ''
  let modifier  =  params.modifier || query.modifier

  if(pageType !== 'team') {
    actualTeam = params.team || query.team || ''
  }else{
    actualTeam = params.teamId || query.id || ''
  }

  let newParams = {
    sport : actualSport,
    root  : currRoot,
    slug  : slug
  }

  if ( actualGameId ) {
    newParams.gameId = actualGameId
  }

  if ( actualTeam ) {
    newParams.team = actualTeam
  }

  if ( actualLeague ) {
    newParams.league = actualLeague
  }

  if ( actualSeason ) {
    newParams.season = actualSeason
  }

  if(actualPlatform) {
    if([ 'ios','android','windows' ].indexOf(actualPlatform) > -1) {
      newParams.platform = actualPlatform
    }else{
      newParams.platform = ''
    }
  }

  if(modifier) {
    newParams.modifier = modifier
  }

  /* get default league if we need to hardcode one */

  /* pagetype can be modified here on a lang/location basis i.e. for es/ar we can take `resultados` and convert to `results`  */

  Object.assign( params, newParams  )

  return params

}



// WEBPACK FOOTER //
// ../app/lib/utils/getRequestParams.js